
const digest = '62a59456c3c1689a7260dbc8755b63245c8f5fa233ad41aa721a6f808c9f9056';
const classes = {"wrapper":"_wrapper_1v4vx_1","background":"_background_1v4vx_7","list":"_list_1v4vx_14","grid":"_grid_1v4vx_23"};
const css = `._wrapper_1v4vx_1 {
  font-family: Rubik, "sans-serif";
  height: 100%;
  display: flex;
  flex-direction: column;
}
._wrapper_1v4vx_1 ._background_1v4vx_7 {
  background: #ffffff;
  padding: 24px;
  border: 1px solid #eaedf3;
  height: 100%;
}

._list_1v4vx_14 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
  gap: 15px;
}

._grid_1v4vx_23 {
  margin: 0 auto;
  display: grid;
  gap: 24px;
}

@media (min-width: 600px) {
  ._grid_1v4vx_23 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 900px) {
  ._grid_1v4vx_23 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  